<!--
 * @Author: Gaho
 * @Date: 2024-07-03 14:08:41
 * @LastEditors: Gaho
 * @LastEditTime: 2024-12-26 15:27:36
 * @Description: 
-->
<template>
    <div class="buttons-col">
        <Button
            @click="$emit('handleAutoPick')"
            class="btn-yellow"
            :disabled="isSubmiting || btnDisabled"
        >
            {{ $t('autoPick') }}
        </Button>
        <Button
            @click="$emit('handleClearTable')"
            class="btn-grey"
            :disabled="isSubmiting || btnDisabled"
        >
            {{ $t('clearPick') }}
        </Button>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'gameControls',
    props: {
        btnDisabled: {
            type: Boolean,
            default: false
        },
        isSubmiting: {
            type: Boolean,
            default: false
        }
    },
    emits: ['handleAutoPick', 'handleClearTable'],
});
</script>